module.exports = __webpack_public_path__ + "img/w35.ba272c4b.svg";